export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-950">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-background-900/50 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
              随时随地，想吃就吃
            </h2>
            <p className="text-background-300/70 text-sm md:text-base leading-relaxed mb-6">
              黑料吃瓜在线移动端专属体验即将上线。无论你是在地铁上、咖啡馆里还是被窝中，打开手机就能第一时间掌握全网最新八卦动态。关注我们，精彩不错过。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#contact"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-notification-3-line text-lg"></i>
                获取上线通知
              </a>
              <span className="text-background-400/50 text-xs">敬请期待</span>
            </div>
          </div>
          <div className="flex-shrink-0 w-48 h-48 md:w-56 md:h-56 rounded-2xl overflow-hidden bg-background-800/50">
            <img
              src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20dark%20theme%20entertainment%20news%20app%20interface%20with%20bold%20headlines%20and%20warm%20accent%20colors%2C%20minimalist%20modern%20design%2C%20clean%20typography%20on%20dark%20background%2C%20editorial%20style&width=600&height=600&seq=app-mockup-2026&orientation=squarish"
              alt="黑料吃瓜在线移动端"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}